/** Situações dos tipos de arquivos */
export enum TipoArquivoSituacao {
    INATIVO = 0,
    ATIVO = 1
}
